import {AtaskVeiklosApi} from './atask-veiklos.api';
import {GiiAtaskKoregavimasApi} from './gii-atask-koregavimas.api';
import {GiiAtaskVertinimasApi} from './gii-atask-vertinimas.api';

export class GiiAtaskaitaApi {
  id!: number | null;
  dokumentoTipas: any;
  ataskLaikotarpis: any;
  giiAtaskVeiklosList: AtaskVeiklosApi[] = [];
  busena: string = '';
  vidineBusena: string = '';
  busenosData!: Date | null;
  clKodas: string = '';
  srautoKodas: string = '';
  giiAtaskKoregavimasList: GiiAtaskKoregavimasApi[] = [];
  giiAtaskVertinimasList: GiiAtaskVertinimasApi[] = [];
  atsakingasVertinimas: any;
  tikslinimoTerminas: any;
}
